import { InitializeActionTypeMapping } from './InitializeAction';
import { ChangeTabActionTypeMapping } from './ChangeTabAction';
import { SearchActionTypeMapping } from './SearchAction';
import { AddMessageActionTypeMapping } from './AddMessageAction';
import { AddAudienceFilterActionTypeMapping } from './AddAudienceFilterAction';
import { FeedReadyActionTypeMapping } from './FeedReadyAction';
import { PreinitializeActionTypeMapping } from './PreinitializeAction';
import { SetHeroBannerActionTypeMapping } from './SetHeroBannerAction';
import { AddBookmarkActionTypeMapping } from './AddBookmarkAction';
import { RemoveBookmarkActionTypeMapping } from './RemoveBookmarkAction';
import { RemoveMessageActionTypeMapping } from './RemoveMessageAction';
import { ShowMoreActionTypeMapping } from './ShowMoreAction';
import { CommentAddedActionTypeMapping } from './CommentAddedAction';
import { LikeAddedActionTypeMapping } from './LikeAddedAction';
import { LikeRemovedActionTypeMapping } from './LikeRemovedAction';
import { RemoveCommentActionTypeMapping } from './RemoveCommentAction';
import { ActivityAddedActionTypeMapping } from './ActivityAddedAction';
import { RemoveAudienceFilterActionTypeMapping } from './RemoveAudienceFilterAction';

export * from './AddCommentAction';
export * from './RemoveCommentAction';
export * from './AddLikeAction';
export * from './RemoveLikeAction';
export * from './InitializeAction';
export * from './ChangeTabAction';
export * from './SearchAction';
export * from './AddTabNotificationAction';
export * from './AddMessageAction';
export * from './RemoveMessageAction';
export * from './AddBookmarkAction';
export * from './RemoveBookmarkAction';
export * from './ShowMoreAction';
export * from './AddAudienceFilterAction';
export * from './RemoveAudienceFilterAction';
export * from './FeedReadyAction';
export * from './SetHeroBannerAction';
export * from './PreinitializeAction';
export * from './ShowMoreAction';
export * from './CommentAddedAction';
export * from './LikeAddedAction';
export * from './LikeRemovedAction';

export const DialogActionTypeMapping: any = {
    ...PreinitializeActionTypeMapping,
    ...InitializeActionTypeMapping,
    ...AddMessageActionTypeMapping,
    ...FeedReadyActionTypeMapping,
    ...ChangeTabActionTypeMapping,
    ...SearchActionTypeMapping,
    ...AddAudienceFilterActionTypeMapping,
    ...SetHeroBannerActionTypeMapping,
    ...AddBookmarkActionTypeMapping,
    ...RemoveBookmarkActionTypeMapping,
    ...RemoveMessageActionTypeMapping,
    ...ShowMoreActionTypeMapping,
    ...CommentAddedActionTypeMapping,
    ...LikeAddedActionTypeMapping,
    ...LikeRemovedActionTypeMapping,
    ...RemoveCommentActionTypeMapping,
    ...ActivityAddedActionTypeMapping,
    ...RemoveAudienceFilterActionTypeMapping
};

